const options = ["Studying", "Working", "Living"];

export default options;
